{
  "shcUi": {
    "banner": {
      "dismiss": "Dismiss",
      "inThisCategory": "in this category"
    },

    "badge": {
      "remove_badge": "Remove badge"
    },

    "breadcrumbs": {
      "homeText": "Home"
    },

    "cart": {
      "empty": "Your cart is empty",
      "offer": "Choose something from our current offer.",
      "goBackToHomepage": "Home page",
      "mini": {
        "cart": "Cart",
        "qty": "Qty",
        "remove": "Remove",
        "subtotal": "Subtotal",
        "shippingAndTaxes": "Shipping and taxes calculated at checkout.",
        "checkout": "Checkout",
        "continueShopping": "Continue Shopping",
        "empty": "Your cart is empty"
      },
      "product": {
        "tile": {
          "quantity": "Quantity",
          "remove": "Remove"
        }
      },
      "modal": {
        "title": "Product has been added",
        "yourProduct": "Your product",
        "insideInCart": "is inside your cart",
        "continueShopping": "Continue shopping or go to checkout",
        "continue": "Continue",
        "goToCart": "Go to cart"
      }
    },

    "catalog": {
      "page": {
        "Products": "Products",
        "products": "products",
        "weHaveGot": "We have got",
        "inThisCategory": "in this category"
      }
    },

    "checkout": {
      "summary": {
        "title": "Order summary",
        "label": "Checkout"
      },
      "saveContinue": "Save & continue"
    },

    "copyrights": {
      "content": "Strix. All rights reserved."
    },

    "dashboard": {
      "title": "Dashboard",
      "welcome": "Welcome to Your Account!"
    },

    "delivery": {
      "title": "Delivery methods",
      "info": "Select delivery method."
    },

    "filters": {
      "title": "Filters",
      "clearAll": "Clear all",
      "price": "price"
    },

    "footer": {
      "heading": "Footer",
      "yourEmail": "Your email",
      "placeholder": "my{'@'}email.com",
      "subscribe": "Subscribe",
      "products": "Products",
      "company": "Company",
      "customerService": "Customer Service",
      "newsletterHeading": "Subscribe to our newsletter",
      "newsletterContent": "The latest deals and savings in your inbox weekly.",
      "goto": "Go to"
    },

    "form": {
      "address": {
        "contactLabel": "Contact information",
        "email": "Email address",
        "shippingLabel": "Shipping information",
        "firstName": "First name",
        "lastName": "Last name",
        "company": "Company",
        "address": "Address",
        "street": "Street",
        "apartment": "Apartment, suite, etc.",
        "city": "City",
        "country": "Country",
        "province": "State / Province",
        "phone": "Phone",
        "postCode": "Postal code",
        "saveAndContinue": "Save & continue",
        "needVatId": "Do you need an invoice for your order?",
        "wantVatId": "I want to receive an invoice",
        "anotherAddress": "Are you ordering to a different address than the recipient's information?",
        "deferentShippingAddress": "Different shipping address",
        "validator": {
          "required": "This is required",
          "email": "Please enter a valid email address.",
          "firstName": "Please enter first name.",
          "lastName": "Please enter last name.",
          "address": "Please enter address.",
          "apartment": "Please enter apartment, suite, etc.",
          "city": "Please enter a city name.",
          "country": "Please enter a country name.",
          "region": "Please enter a state / province.",
          "postalCode": "Please enter a postal code.",
          "telephone": "Please enter a valid phone number.",
          "street": "Please enter a valid street.",
          "config": {
            "emailMinLength": "1",
            "firstNameMinLength": "3",
            "lastNameMinLength": "3",
            "addressMinLength": "3",
            "apartmentMinLength": "1",
            "cityMinLength": "3",
            "countryMinLength": "3",
            "regionMinLength": "3",
            "postalCodeMinLength": "5",
            "telephoneLength": "9"
          }
        }
      },
      "email": {
        "change": {
          "emailAddress": "Email address",
          "newEmailHelp": "If you want to change the email address, just type in a new one.",
          "changeEmail": "Change email address",
          "emailChangeRequestSent": "We have sent a message to the current email requesting consent to change the the current email to a new one.",
          "ok": "OK"
        }
      },
      "login": {
        "title": "Sign In to Your Account",
        "apply": "Apply",
        "emailAddress": "Email address",
        "password": "Password",
        "rememberMe": "Remember me",
        "forgotPassword": "Forgot password?",
        "signIn": "Sign In",
        "continueWith": "Or continue with",
        "whyHaveAccount": "Why have an account?",
        "createAccount": "Create Account"
      },
      "password": {
        "change": {
          "changePassword": "Change password",
          "enterNewPassword": "Enter a new password.",
          "newPassword": "New password",
          "repeatPassword": "Repeat new password",
          "placeholder": "Eg. name{'@'}example.com",
          "cancel": "Cancel",
          "passwordChanged": "Your password has been changed.",
          "ok": "OK"
        },
        "reset": {
          "title": "Have you forgotten your password?",
          "info": "Please enter your email address below to receive a link to reset your password.",
          "send": "Send",
          "confirmation": "If there is a user account associated with the entered email address, an email will be sent with a link to reset your password"
        }
      },
      "register": {
        "email": "Email address",
        "password": "Password",
        "repeat": "Repeat password",
        "minCharacters": "Minimum 6 characters",
        "firstName": "First name",
        "lastName": "Last name",
        "company": "Company",
        "address": "Address",
        "apartment": "Apartment, suite, etc.",
        "city": "City",
        "country": "Country",
        "region": "State / Province",
        "phone": "Phone",
        "postCode": "Postal code",
        "createAccount": "Create account",
        "iHaveAccount": "I have an account",
        "logIn": "Log in",
        "continueWith": "Or continue with",
        "billingInformation": "Billing information"
      },
      "discount": {
        "discountCode": "Discount code",
        "apply": "Apply",
        "applied": "Applied",
        "used": "Used",
        "invalid": "Invalid",
        "withdraw": "Withdraw",
        "useAnother": "Use another",
        "placeholder": "Enter your discount code"
      },
      "contact": {
        "name": "Name",
        "heading": "Send us a message",
        "email": "Email address",
        "placeholder": "Eg. name{'@'}example.com",
        "message": "Message",
        "sendMessage": "Send us a message"
      }
    },

    "header": {
      "closeMenu": "Close menu",
      "shopNow": "Shop now",
      "countryCode": "CAD",
      "changeCurrency": ", change currency",
      "openMenu": "Open menu",
      "search": "Search",
      "account": "Account",
      "viewBag": "view bag",
      "favourites": "Favourites",
      "all": "View all products"
    },

    "headerSearch": {
      "contact": "Contact"
    },

    "input": {
      "search": {
        "placeholder": "Im looking for...",
        "label": "Search"
      }
    },

    "logout": {
      "loggingOut": "Logging out..."
    },

    "mydata": {
      "title": "My Data"
    },

    "notification": {
      "close": "Close"
    },

    "offer": {
      "parameter": {
        "inStock": "In stock",
        "shipsIn": "Ships in",
        "freeDelivery": "Free delivery over 100 zł",
        "freeReturn": "30 days for free return"
      }
    },

    "order": {
      "details": {
        "orderNo": "Order No",
        "date": "Date",
        "total": "Total",
        "status": "Status",
        "downloadInvoice": "Download invoice",
        "return": "Return",
        "items": "Items",
        "yourInformation": "Your information",
        "paymentMethod": "Payment method",
        "shippingMethod": "Shipping method",
        "summary": "Summary",
        "orderedProducts": "Ordered products",
        "trackingNo": "Order tracking number",
        "track": "Track your order",
        "yourOrder": "Your Order"
      }
    },

    "orders": {
      "title": "Orders",
      "youHave": "You have",
      "activeOrders": "active orders",
      "noProducts": "You have not ordered any products yet",
      "startShopping": "Start shopping",
      "table": {
        "no": "No",
        "date": "Date",
        "total": "Total",
        "status": "Status",
        "actions": "Actions",
        "details": "Details",
        "return": "Return"
      }
    },

    "page": {
      "error": {
        "message": "error",
        "goBackHome": "Go back home"
      }
    },

    "pagination": {
      "prev": "Previous",
      "next": "Next",
      "summary": {
        "showing": "Showing",
        "from": "from"
      }
    },

    "payment": {
      "methods": {
        "title": "Payment method",
        "validationTitle": "Select payment method.",
        "cardNumber": "Card Number",
        "nameOnCard": "Name on Card",
        "expirationDate": "Expiration date (MM/YY)",
        "cvc": "CVC"
      }
    },

    "product": {
      "card": {
        "additionalDetails": "Additional details",
        "addToCart": "Add to cart",
        "description": "Description",
        "productInformation": "Product information",
        "reviews": "reviews",
        "sku": "Code"
      },
      "tile": {
        "reviews": "reviews",
        "addToCart": " Add to cart",
        "mini": {
          "quantity": "Qty",
          "remove": "Remove"
        }
      }
    },

    "rating": {
      "stars": {
        "reviews": "reviews"
      }
    },

    "select": {
      "chooseOptions": "Choose options",
      "notifyMe": "Notify me"
    },

    "sidebar": {
      "navigation": {
        "openNavigation": "Navigate Account",
        "closeNavigation": "Close navigation"
      }
    },

    "stock": {
      "inStock": "In stock",
      "leadTime": "3-4 days",
      "shipsIn": "Ships in"
    },

    "topbar": {
      "contact": "Contact"
    },

    "totals": {
      "total": "Total",
      "subtotal": "Subtotal",
      "shipping": "Shipping",
      "taxes": "Taxes",
      "discount": "Discount total"
    },

    "languages": {
      "en": "English",
      "pl": "Polish",
      "de": "German"
    }
  }
}
